import { useEffect, useState } from "react";
import {
    MDBBtn,
    MDBCard,
    MDBCardHeader,
    MDBIcon,
    MDBRow,
} from "mdb-react-ui-kit";
import TextareaAutosize from "react-textarea-autosize";
import {
    loadChatBot,
    setTypingMessageEffect,
    useChatbotSelector,
} from "../store/ChatBotStore.ts";
import {
    SendIcon,
} from "../../../assets/images/index.js";
import ChatBotList from "./ChatBotList.tsx";
import { ChatBotHelper } from "../handlers/ChatBotHelper.ts";

import { useDispatch } from "react-redux";
import { getAskLunaView, saveAskLunaView } from "../../../../apiclients/streamsapi_bridge.js";
import React from "react";

export default function ChatBotView({ open, setOpen, setTDocked, setTOpenDocked }) {


    // Use the correct typed dispatch for thunks
    const dispatch = useDispatch();

    const [input, setInput] = useState("");
    const [messageLimitShow, setMessageLimitShow] = useState(false);
    const [isSending, setIsSending] = useState(false);

    const activeTab = useChatbotSelector((state) => state.chatbot.activeChatBotTab);
    const isReceiverLoader = useChatbotSelector((state) => state.chatbot.isReceiverLoader);
    const typingMessageEffect = useChatbotSelector((state) => state.chatbot.typingMessageEffect);


    const chatbotList = useChatbotSelector(
        (state) => state.chatbot.byType[activeTab] ?? []
    );

    const CHATBOT_MESSAGES_LENGTH_LIMIT = 256;

    useEffect(() => {
        console.log(`[ChatBotTabs.useEffect] chatbotList: ${chatbotList.length} `);
        if (!chatbotList || chatbotList.length === 0) {
            dispatch(loadChatBot(activeTab));
        }
    }, [activeTab]);

    const handleToggle = () => {
        dispatch(setTypingMessageEffect(false)); // <- Set typing effect to false when toggled
        setOpen(!open);
        const adminSession = sessionStorage.getItem("admin_session");
        const siteid = adminSession ? JSON.parse(adminSession)?.siteid : null;
        saveAskLunaView({
            siteid: siteid,
            asklunaview: open ? 0 : 1,
        });
        setTOpenDocked(open ? false : true);
    };

    const handleSend = async () => {

        if (isReceiverLoader) {// check loader is true or false

            console.log("currently one message is process please wait for message to complete");
            return;
        }

        if (!input.trim()) return;
        if (input.length > CHATBOT_MESSAGES_LENGTH_LIMIT) {
            setMessageLimitShow(true);
            return;
        }

        ChatBotHelper.getInstance().sendMessage(input.trim(), activeTab);

        setInput("");
        setMessageLimitShow(false);

    };

    const [docked, setDocked] = useState<boolean>(false);

    const getALView = async () => {
        const adminSession = sessionStorage.getItem("admin_session");
        const siteid = adminSession ? JSON.parse(adminSession)?.siteid : null;
        if (!siteid) {
            console.warn("Site ID not found in session.");
            fallbackToSessionValues();
            return;
        }
        try {
            const response = await getAskLunaView(siteid);
            const respData = await response.json();
            const asklunaview = respData.asklunaview;
            if (asklunaview === undefined || asklunaview === null) {
                fallbackToSessionValues();
                return;
            }
            const docked = asklunaview === 2;
            setDocked(docked);
        } catch (error) {
            console.error("getALView failed:", error);
            fallbackToSessionValues();
        }
    };

    const fallbackToSessionValues = () => {
        const isDoced = sessionStorage.getItem("chatbotDocked") === "true" ? true : false;
        setDocked(isDoced);
    };

    useEffect(() => {
        getALView();
    }, []);
    const saveALView = (docked: boolean) => {
        setDocked(docked);
        const adminSession = sessionStorage.getItem("admin_session");
        const siteid = adminSession ? JSON.parse(adminSession)?.siteid : null;
        if (docked) {
            setTOpenDocked(true);
            saveAskLunaView({
                siteid: siteid,
                asklunaview: 2,
            });
        } else {
            saveAskLunaView({
                siteid: siteid,
                asklunaview: 1,
            });
        }
        setTDocked(docked)
    };


    return (
        <>
            {open && (
                <MDBRow className={`d-flex justify-content-center chatbotCard ${docked ? "docked" : ""}`}>
                    <MDBCard className="p-0 mdb-card-container">
                        <MDBCardHeader className="d-flex justify-content-center justify-content-between">
                            <div className="d-flex align-items-center justify-content-between w-100">
                                <p className="fw-bold ps-2">Need help? Ask Luna</p>
                                <div className="d-flex">
                                    <div className="d-flex align-items-right justify-content-end">
                                        {/* Dock/Undock Icon */}
                                        <div
                                            onClick={() => saveALView(!docked)}
                                            role="button"
                                            tabIndex={0}
                                            className="cursor-pointer me-3"
                                            title={docked ? "Undock" : "Dock to side"}
                                        >
                                            <MDBIcon fas icon={docked ? "window-restore" : "window-maximize"} color="white" />
                                        </div></div>
                                    {/* Close Icon */}
                                    <div onClick={handleToggle} tabIndex={0} role="button" className="cursor-pointer">
                                        <MDBIcon fas icon="times" color="white" size="lg" />
                                    </div>
                                </div>
                            </div>
                        </MDBCardHeader>

                        <ChatBotList dispatch={dispatch}
                            activeTab={activeTab}
                            isReceiverLoader={isReceiverLoader}
                            typingMessageEffect={typingMessageEffect} />

                        <div className="chat-input-container ">
                            <TextareaAutosize
                                minRows={1}
                                maxRows={6}
                                className="chat-input"
                                placeholder="Ask a Question"
                                value={input}
                                onChange={(e) => setInput(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter" && !e.shiftKey && !isSending) {
                                        e.preventDefault();
                                        handleSend();
                                    }
                                }}
                            />
                            <MDBBtn className="ms-2 send-button p-0" onClick={handleSend} disabled={isReceiverLoader}>
                                <img
                                    src={SendIcon}
                                    width="20px"
                                    height="20px"
                                    alt="send"
                                    className="send-icon p-0"
                                /></MDBBtn>
                        </div>
                        {messageLimitShow && (
                            <>
                                <div
                                    className="text-danger text-start py-1 px-3 mb-2 bg-danger bg-opacity-25 rounded-3  border border-danger border-2 d-flex align-items-center justify-content-between"
                                    style={{ margin: "-10px 1.5rem 1.5rem 1.5rem" }}
                                >
                                    <p className="text-danger">
                                        Please enter a message within 256 characters.
                                    </p>
                                    <MDBIcon fas icon="times" color="danger" />
                                </div>
                            </>
                        )}
                    </MDBCard>
                </MDBRow>
            )}
        </>
    );
}